import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import CdnImage from '../../common/CdnImage';
import { StyledWebView } from '../../common/StyledWebView';
import LayoutContext from '../../../contexts/Layout';

export const Streaming = ({ items, nodeTypeAlias = 'Streaming', width }) => {
    const { layout } = useContext(LayoutContext);
    const streams = Object.values(items);

    if (streams?.length === 0) {
        return null;
    }

    return (
        <View style={Styles.wrapper} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {streams.map((stream, idx) => {
                const id = stream?.id;

                return (
                    <View
                        key={id || idx}
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <CdnImage
                            uri={stream.image.cdnImagePath}
                            style={{ marginBottom: layout.styleGuide.spacer2 }}
                            dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                            width={!layout.device.os.equals('web') ? Math.floor(layout.dimensions.width / 2) : undefined}
                        />
                        <View
                            style={{ marginHorizontal: layout.styleGuide.spacer1 }}
                            dataSet={{ spacerLeft: `StyleGuide.spacer1(${layout.styleGuide.spacer1})`, spacerRight: `StyleGuide.spacer1(${layout.styleGuide.spacer1})` }}
                        >
                            <StyledWebView html={stream.description} width={width} />
                        </View>
                    </View>
                );
            })}
        </View>
    );
};

const Styles = StyleSheet.create({
    wrapper: {
        justifyContent: 'center',
        width: '100%'
    }
});

Streaming.propTypes = {
    items: PropTypes.object
};
